/// <amd-module name="Wit/LinkedWorkItemsDropdown/LinkedWorkItemsCommitDetailViewService" />
import { IReadyableReadonlyObservableArray } from "VSS/Core/Observable";
import { IVssPageContext, IVssService, Services } from "VSS/Platform/Context";
import { LinkedWorkItemsBaseDetailViewService } from "./LinkedWorkItemsBaseDetailViewService";
import { getLinkedWorkItemsService } from "./LinkedWorkItemsService";
import { IWorkItemEntry } from "Util/Data"

export interface ILinkedWorkItemsCommitDetailViewService extends IVssService {
    getLinkedWorkItems(projectId: string, repositoryId: string, commitId: string): IReadyableReadonlyObservableArray<IWorkItemEntry>;
}

class LinkedWorkItemsCommitDetailViewService extends LinkedWorkItemsBaseDetailViewService implements ILinkedWorkItemsCommitDetailViewService {
    protected getLinkedWorkItemPromise(projectId: string, repositoryId: string, id: string): Promise<number[]> {
        const linkedWorkItemService = getLinkedWorkItemsService(this.pageContext);
        return linkedWorkItemService.getLinkedCommitWorkItemIds(projectId, repositoryId, id);
    }

    public getLinkedWorkItems(projectId: string, repositoryId: string, commitId: string): IReadyableReadonlyObservableArray<IWorkItemEntry> {
        return super.getLinkedWorkItems(projectId, repositoryId, commitId);
    }
}

const serviceName = "ILinkedWorkItemsCommitDetailViewService";
export function getLinkedWorkItemsCommitDetailViewService(pageContext: IVssPageContext) {
    return pageContext.getService<ILinkedWorkItemsCommitDetailViewService>(serviceName);
}

Services.add(serviceName, { serviceFactory: LinkedWorkItemsCommitDetailViewService });
